import { Button, Modal } from 'antd'
import React, { useState } from 'react'
import gloss from '../Components/fayl/GLOSSARIY.pdf'


export const Glossariy = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const showModal = () => {
        setIsModalOpen(true);
    };
    return (
        <div className="card" >
            <Button className='button' onClick={showModal}>
                <a href={gloss}>Glossariy </a>
            </Button>
        </div>
    )
}